function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M68 30C63 30 62.1506 22.5 60.8219 19.1368C59.3362 15.3757 57.1584 11.9583 54.413 9.07969C51.6676 6.20107 48.4084 3.91763 44.8214 2.35973C41.2344 0.801838 37.3898 -1.77948e-07 33.5073 0C29.6247 1.77948e-07 25.7801 0.801839 22.1931 2.35974C18.6061 3.91763 15.3469 6.20107 12.6015 9.07969C9.8561 11.9583 7.67834 15.3757 6.19255 19.1368C4.70675 22.8979 5 30 3.51397e-09 30H33.5073H68Z",
  fill: "#242F39"
});

const SvgActiveLinkBorder = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 68,
  height: 30,
  viewBox: "0 0 68 30",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActiveLinkBorder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/active-link-border.47f3ef6a.svg";
export { ForwardRef as ReactComponent };